"use strict";
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        /**
         * Specify a set of options that we only want to fire once when any of them change while the control is updating
         * @internal
         */
        function controlOptions(options, control) {
            // Temporary helper method used for shared controls code that instantiates $dyn.options objects.
            // If bindUpdate is specificed for the control then no options computed object is created.
            if (control && control.bindUpdate) {
                var actualOptions = void 0;
                if (typeof options === "function") {
                    actualOptions = options();
                }
                else {
                    actualOptions = options;
                }
                // tslint:disable-next-line:forin
                for (var v in actualOptions) {
                    actualOptions[v] = $dyn.peek(actualOptions[v]);
                }
                return actualOptions;
            }
            else {
                return $dyn.options(options, control.Updating);
            }
        }
        ui.controlOptions = controlOptions;
        /**
         * Set up a computed based on the relevant properties for a control that has a link
         * @internal
         */
        function link(control) {
            return $dyn.ui.controlOptions(function () {
                var labelledByData = control.getLabelledByData && control.getLabelledByData();
                var showLabel = labelledByData ? labelledByData.showLabel && !labelledByData.isInGrid : true;
                return {
                    byElementId: labelledByData && showLabel ? labelledByData.byElementId : "",
                    click: control.ExecuteHyperlink,
                    label: labelledByData && !showLabel ? labelledByData.label : "",
                    readonly: control.readOnly,
                    showLink: control.showLink,
                    value: control.Value,
                };
            }, control);
        }
        ui.link = link;
        /**
         * Set up a computed based on the relevant properties for a control that has a preview
         * @internal
         */
        function preview(control) {
            return $dyn.ui.controlOptions(function () {
                return {
                    CanHavePreview: control.CanHavePreview,
                    RequestEnhancedPreview: control.RequestEnhancedPreview,
                };
            }, control);
        }
        ui.preview = preview;
        /**
         * handles stripping out helptext and returning to binder
         * @internal
         * @param control the current control
         */
        function fieldOptions(control) {
            return $dyn.ui.controlOptions(function () {
                return {
                    // are we view mode and user clicked a editable cell?
                    AllowTyping: control.allowTyping ? control.allowTyping() : false,
                };
            }, control);
        }
        ui.fieldOptions = fieldOptions;
        /**
         * handles stripping out helptext and returning to binder
         * @internal
         */
        function superTooltip(control) {
            return $dyn.ui.controlOptions(function () {
                return {
                    HelpText: control.HelpText,
                };
            }, control);
        }
        ui.superTooltip = superTooltip;
        /**
         * Set up a computed based on the relevant properties for a control that has a status indicator
         * @internal
         */
        function status(control) {
            var options = {
                "": $dyn.ui.StatusIndicator.none,
                "Required-symbol statusMandatory": $dyn.ui.StatusIndicator.mandatory,
                "Warning-symbol statusWarning": $dyn.ui.StatusIndicator.warning,
            };
            return $dyn.ui.controlOptions(function () {
                return { value: control.StatusIndicator, options: options };
            }, control);
        }
        ui.status = status;
        /**
         * Set up a computed based on Style the style property for a checkbox
         * @internal
         */
        function checkBoxStyle(control) {
            var options = {
                autoStyle: $dyn.ui.CheckBoxStyle.auto,
                standardStyle: $dyn.ui.CheckBoxStyle.checkbox,
                toggleStyle: $dyn.ui.CheckBoxStyle.toggle,
            };
            return $dyn.ui.controlOptions(function () {
                return { value: control.Style, options: options };
            }, control);
        }
        ui.checkBoxStyle = checkBoxStyle;
        /**
         * Represents the standard skip behavior for controls that have Skip and Enabled properties
         * @internal
         */
        function skip(control) {
            return $dyn.ui.controlOptions(function () {
                return { skip: control.Skip, enabled: control.Enabled, visible: control.Visible };
            }, control);
        }
        ui.skip = skip;
        /**
         * Represents the standard skip behavior for controls that have ImageName and ImageType properties
         * @internal
         */
        function img(control) {
            return $dyn.ui.controlOptions(function () {
                return { imageName: control.ImageName, imageType: control.ImageType };
            }, control);
        }
        ui.img = img;
        /**
         * Creates the object needed for the $dyn.bindingHandlers.labelFor binding handler
         * @internal
         */
        function labelFor(forElement, control, showLabel, emptyStr) {
            if (showLabel === undefined) {
                if (control.ShowLabel === undefined) {
                    showLabel = !!(control.Label || emptyStr !== undefined);
                }
                else {
                    showLabel = control.ShowLabel;
                }
            }
            return $dyn.ui.controlOptions(function () {
                return { forElement: forElement, text: control.Label, showLabel: showLabel, emptyStr: emptyStr };
            }, control);
        }
        ui.labelFor = labelFor;
        /**
         * Creates the object needed for the $dyn.bindingHandlers.ariaLabelFor binding handler
         * @internal
         */
        function ariaLabelFor(forElementId, control, showLabel, emptyStr) {
            if (showLabel === undefined) {
                if (control.ShowLabel === undefined) {
                    showLabel = !!(control.Label || emptyStr !== undefined);
                }
                else {
                    showLabel = control.ShowLabel;
                }
            }
            return $dyn.ui.controlOptions(function () {
                return { forElementId: forElementId, text: control.Label, showLabel: showLabel, emptyStr: emptyStr };
            }, control);
        }
        ui.ariaLabelFor = ariaLabelFor;
        /**
         * Creates the object needed for the $dyn.bindingHandlers.ariaLabel binding handler
         * @internal
         */
        function ariaLabel(control) {
            return $dyn.ui.controlOptions(function () {
                return { label: control.Label };
            }, control);
        }
        ui.ariaLabel = ariaLabel;
        /**
         * Creates the object needed for the $dyn.bindingHandlers.ariaLabelImage binding handler
         * @internal
         */
        function ariaLabelImage(control) {
            return $dyn.ui.controlOptions(function () {
                return {
                    id: control.Id,
                    imageName: $dyn.value(control.ImageName),
                    label: $dyn.value(control.Label),
                    name: control.Name,
                    toolTip: $dyn.value(control.Tooltip),
                    type: $dyn.value(control.ImageType)
                };
            }, control);
        }
        ui.ariaLabelImage = ariaLabelImage;
        function summaryFieldLink(control) {
            return $dyn.options(function () {
                return {
                    click: control.ExecuteHyperlink,
                    readonly: true,
                    showLink: $dyn.value(control.IsHyperlink) && $dyn.value(control.Enabled) && $dyn.value(control.IsValid) && $dyn.value(control.formattedValue),
                    stopPropagation: true,
                    value: $dyn.value(control.Label) + ": " + $dyn.value(control.formattedValue),
                };
            }, control.Updating);
        }
        ui.summaryFieldLink = summaryFieldLink;
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ControlOptions.js.map
